import { ListingZaEntreprisesResolve } from './zone-activite/listing/resolve/listing.resolve.service';
import { ListingEntreprisesComponent } from './zone-activite/listing/listing.component';
import { SingleLocalResolve } from './locaux/single-local/resolver/single-local.resolve.service';
import { FormLocauxResolve } from './locaux/form-locaux/resolver/form-locaux.resolve.service';
import { FormAnnuaireResolve } from './annuaire/form/resolver/form.resolve.service';
import { ListingComponent } from './annuaire/listing/listing.component';
import { FormComponent } from './annuaire/form/form.component';
import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SingleComponent } from './annuaire/single/single.component';
import { SingleAnnuaireResolve } from './annuaire/single/resolver/single.resolve.service';
import { FormLocauxComponent } from './locaux/form-locaux/form-locaux.component';
import { ListingLocauxComponent } from './locaux/listing-locaux/listing-locaux.component';
import { SingleLocalComponent } from './locaux/single-local/single-local.component';
import { LocalByZaComponent } from './locaux/filter/local-by-za.component';


const routes: Routes = [

  /* ROUTING PROCESS : ANNUAIRE */ 

  {
    path: 'annuaire', 
    component : FormComponent,
    pathMatch: 'full',
    resolve : {
      results : FormAnnuaireResolve
    }
  },
  {
    path : 'annuaire/entreprise/:id',
    component : SingleComponent,
    resolve : {
      entreprise : SingleAnnuaireResolve
    }
  },

  /* ROUTING PROCESS : LOCAUX */ 

  {
    path: 'locaux', 
    component : FormLocauxComponent,
    pathMatch: 'full',
    resolve : {
      results : FormLocauxResolve
    }
  },
  {
    path: 'locaux/za/:id',
    component: FormLocauxComponent,
    pathMatch: 'full',
    resolve: {
      results: FormLocauxResolve
    }
  },
  /*{
    path: 'locaux/listing/:offset',
    component : ListingLocauxComponent,
    resolve : {
      results : ListingLocauxResolve
    }
  },*/
  {
    path : 'local/:id',
    component : SingleLocalComponent,
    resolve : {
      local : SingleLocalResolve
    }
  },
  {
    path: 'local/by_za/:id',
    component: LocalByZaComponent
  },
  {
    path: 'za/:id',
    component: ListingEntreprisesComponent,
    resolve: {
      local: ListingZaEntreprisesResolve
    }
  }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ],
  providers : [
    SingleAnnuaireResolve,
    FormAnnuaireResolve,
    FormLocauxResolve,
    SingleLocalResolve,
    ListingZaEntreprisesResolve
  ]
})

export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts